// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"206":"eb75fa7b","453":"f394a27d","501":"a603b4ca","606":"a88db924","925":"27ef862e"}[chunkId] + ".chunk.js";
};